export const checkIfSortPathsAreMatching = (sortConfig1, sortConfig2) => {
  const key1 = sortConfig1 && Object.keys(sortConfig1)[0];
  const key2 = sortConfig2 && Object.keys(sortConfig2)[0];
  return key1 && key2 && key1 === key2;
};
